import React from 'react'
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Table } from '../../Table';
import { AlertTriangle, Search } from 'react-feather';
import { startloadSaleReport } from '../../../../app/store/sales/thunks';
import { startloadOrden } from '../../../../app/store/ordenes/thunks';
import { loadPerformanceEmp } from '../../../../app/store/reportes/thunks';

export const PerformanceEmployee = () => {

    const { register, handleSubmit, watch, reset, getValues, setValue, formState: { errors } } = useForm({ model: 'all' });
    const { empleados } = useSelector(state => state.empleados);
    const { isLoading, status_report, performanceEmployee, performanceTotalesEmployee, grantotalPerformance } = useSelector(state => state.reportes);
    let f = new Date(); let dia = f.getDate(); let mes = f.getMonth() + 1; if (dia < 10) dia = "0" + dia; if (mes < 10) mes = "0" + mes; let today = f.getFullYear() + "-" + mes + "-" + dia;
    const dispatch = useDispatch();


    const searchData = (data) => {
        // console.log(data);
        dispatch(loadPerformanceEmp(data.fechaInicial, data.fechaFinal, data.tecnico))
    }

    const loadFolio = (folio) => {
        if (folio.includes("HDLV")) {
            dispatch(startloadSaleReport(folio))
        } else {
            dispatch(startloadOrden(folio));
        }
    }

    const dataU = [...performanceEmployee];

    const columnsType = [
        {
            header: 'FOLIO',
            dataIndex: 'FOLIO',
            classHeader: 'text-center',
            classRow: 'text-center fw-bold text-primary',
            renderer: (value) => (
                <>
                    <button type="button" className="btn btn-link" data-bs-toggle="modal" data-bs-target="#detailFolio" onClick={() => loadFolio(value)}>{value}</button>
                </>
            ),
        },
        {
            header: 'ASIGNACIÓN',
            dataIndex: 'FECHA_ASIGNACION',
            classHeader: 'text-center',
            classRow: 'text-center',
        },
        {
            header: 'TERMINADA / COMPLETADA',
            dataIndex: 'FECHA_COMPLETADA',
            classHeader: 'text-center',
            classRow: 'text-center',
        },
        {
            header: 'CERRADA',
            dataIndex: 'FECHA_CERRADA',
            classHeader: 'text-center',
            classRow: 'text-center',
        },
        {
            header: 'COMENTARIOS',
            dataIndex: 'CATEGORIA',
            classHeader: 'text-start',
            classRow: 'text-start',
        },
    ];

    const columnsType2 = [

        {
            header: 'EMPLEADO',
            dataIndex: 'NOMBRE',
            classHeader: 'text-start',
            classRow: 'text-start',
        },
        {
            header: 'ORDENES ASIGNADAS',
            dataIndex: 'ORDENES_ASIGNADAS',
            classHeader: 'text-center',
            classRow: 'text-center',
        },
        {
            header: 'ORDENES TERMINADAS',
            dataIndex: 'ORDENES_TERMINADAS',
            classHeader: 'text-center',
            classRow: 'text-center',
        },
        {
            header: 'TERMINADAS ADICIONALES',
            dataIndex: 'ORDENES_EXTRA_CERRADAS',
            classHeader: 'text-center',
            classRow: 'text-center',
        },
       
    ];



    const tecnicoSelected = watch("tecnico");

    const selectedColumns = tecnicoSelected && tecnicoSelected !== "0"
        ? columnsType    // Si selecciona un empleado en específico
        : columnsType2;  // Si selecciona "TODOS"

    const showtotals = tecnicoSelected && tecnicoSelected !== "0"
        ? false    // Si selecciona un empleado en específico
        : true;  // Si selecciona "TODOS"



        // console.log(grantotalPerformance?.ORDENES_TOTAL_FINAL);
        

    return (
        <div className=''>
            <div className='border-bottom'>
                <h2 className="h5 fw-bold">Ordenes</h2>
            </div>
            <div>
                <div className="card-body">

                    <form className='row' onSubmit={handleSubmit(searchData)} >

                        <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3 mb-2'>
                            <label className="form-label">Tecnico:</label>

                            <select className="form-select " defaultValue={'0'}  {...register("tecnico")} >
                                <option value={'0'} >TODOS</option>
                                {
                                    empleados.map((item, index) => (
                                        item.ESTADO == 1 && item.ROL_ID == 3 ? <option key={index} value={item.ID} className='text-uppercase' >({item.USER}) | {item.NOMBRE} </option>
                                            : <option key={index} style={{ display: "none" }} ></option>
                                    ))
                                }
                            </select>
                        </div>
                        <div className="col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
                            <label className="form-label">Fecha de Inicio:</label>
                            <input type="date" className="form-control" {...register("fechaInicial", { required: 'Introduce fecha de inicio' })} />
                            {
                                errors.fechaInicial &&
                                <div className='text-left-5 mt-2'>
                                    <AlertTriangle size="18" color="#dc3545" />
                                    <span className='text-left-10 fw-bold text-danger'><small>{errors.fechaInicial.message}</small></span>
                                </div>
                            }
                        </div>
                        <div className="col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 col-xxl-2  ">
                            <label className="form-label">Fecha de Termino:</label>
                            <input type="date" className="form-control" defaultValue={today} {...register("fechaFinal")} />
                        </div>

                        <div className="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 col-xxl-2 mt-1">
                            <div className="mb-3 mt-4">
                                <button type="submit" className="btn btn-outline-secondary">
                                    <Search size="20" /> Buscar
                                </button>
                            </div>
                        </div>
                    </form>
                    <hr className='my-0' />
                    <div className=' col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12'>
                        <div className=" mt-3">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col mt-0">
                                        <h5 className="card-title text-dark">Conteo por estado: </h5>
                                    </div>

                                </div>
                                <div className='text-center table-responsive'>
                                    <table className="table table-hover table-sm">
                                        <thead>
                                            <tr>

                                                <th scope="col" className='text-center'>TOTAL</th>
                                                <th scope="col" className='text-center'>EN PROCESO</th>

                                                {/* Condiconar esta columna debe aparecer cuando no haya seleccionado ningun tecnio */}
                                                {tecnicoSelected =='0'  && (
                                                    <th scope="col" className="text-center">SIN ASIGNAR</th>
                                                )}
                                                <th scope="col" className='text-center'>CANCELADAS</th>
                                                <th scope="col" className='text-center'>TERMINADAS</th>
                                                <th scope="col" className='text-center'>TERMINADAS ADICIONALES</th>
                                                <th scope="col" className='text-center'>CANCELADAS ADICIONALES</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                performanceTotalesEmployee?.length == 0 ?
                                                    <>
                                                        <tr>
                                                            <td colSpan={6}>No hay datos por mostrar</td>
                                                        </tr>
                                                    </> :
                                                    performanceTotalesEmployee?.map((item, index) => (
                                                        <tr key={index}>
                                                            <td className="text-center"> 

                                                           {tecnicoSelected !=='0' ? (
                                                            <>{item.ORDENES_TOTALES_CERRADAS_2}/{Number(grantotalPerformance?.ORDENES_TOTAL_FINAL)}</>
                                                            ) : (
                                                            <>{Number(grantotalPerformance?.ORDENES_TOTAL_FINAL)}</>
                                                            )}
                                                                                                            
                                                                </td>
                                                            
                                                            <td className="text-center">{item.ORDENES_EN_PROCESO}</td>
                                                            {/* Condiconar esta columna debe aparecer cuando no haya seleccionado ningun tecnio */}

                                                              {tecnicoSelected =='0'  && (
                                                                <td className="text-center"> {Number(item?.ORDENES_SIN_ASIGNAR)}</td>
                                                            )}
                                                           
                                                            <td className="text-center">{Number(item.ORDENES_CANCELADAS)}</td>
                                                            <td className="text-center">{item.ORDENES_ENTREGADAS}</td>
                                                            <td className="text-center">{item.ORDENES_EXTRA_CERRADAS}</td>
                                                            <td className="text-center">{Number(item.ORDENES_EXTRA_CANCELADAS) }</td>
                                                        </tr>
                                                    ))
                                            }
                                        </tbody>
                                    </table>

                                </div>

                            </div>
                        </div>
                    </div>

                    <h5 className='fw-bold mt-2'>Resultados</h5>

                    <Table columns={selectedColumns} data={dataU} function_={[]} placeholderSearch="Buscar servicio" showPagination={true} showControls={true} showTotals={showtotals} />

                </div>
            </div>




        </div>
    )
}
